import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckDouble, faChevronsRight, faCommentsQuestionCheck } from '@fortawesome/pro-duotone-svg-icons';
import Button from '@/components/common/Button';
import { useEffect, useState } from 'react';

type SubscriptionCardButtonType = {
  type: 'current' | 'choose' | 'on request';
  onClick?: () => void;
  disabled?: boolean;
};

const SubscriptionCardButton = ({ type, onClick, disabled }: SubscriptionCardButtonType) => {
  const [label, setLabel] = useState('');

  useEffect(() => {
    const updateLabel = () => {
      const breakpoint = 640;

      if (window.innerWidth < breakpoint) {
        setLabel('');
      } else {
        switch (type) {
          case 'current':
            setLabel('Aktuelles Abonnement');
            break;
          case 'choose':
            setLabel('Jetzt wechseln');
            break;
          case 'on request':
            setLabel('Auf Anfrage');
            break;
          default:
            setLabel('');
        }
      }
    };

    updateLabel();
    window.addEventListener('resize', updateLabel);

    return () => window.removeEventListener('resize', updateLabel);
  }, [type]);

  const handleRequestEnterpriseSubscriptionClick = () => {
    window.open('mailto:kontakt@vergabepilot.ai?subject=Abonnement%20Anfrage');
  };

  switch (type) {
    case 'current':
      return (
        <button
          disabled
          className="flex w-fit items-center gap-0.5 rounded-xl px-3 py-3 text-center text-sm font-normal"
        >
          <FontAwesomeIcon icon={faCheckDouble} className={`h-3 w-3`} />
          <span className="text-[#939BA4]">{label}</span>
        </button>
      );
    case 'choose':
      return (
        <Button
          label={label}
          onClick={onClick}
          buttonClassName="px-3 py-3"
          icon={faChevronsRight}
          variant="secondary"
          disabled={disabled}
        />
      );
    case 'on request':
      return (
        <Button
          label={label}
          onClick={handleRequestEnterpriseSubscriptionClick}
          buttonClassName="px-3 py-3"
          icon={faCommentsQuestionCheck}
          variant="secondary"
          disabled={disabled}
        />
      );
  }
};

export default SubscriptionCardButton;
